import type { LibItemSysImage } from '@types';
import { HOST } from './constants.domain';

export const LOGO_URL = '/imgs/logo.ad7085bb1ef3365ce10bb7fac31fa859.png';

export const PAGE_SIZE = 30;

export const TITLE_LENGTH = 500;

export const THUMB_SIZE_LIMIT = 614400; // 600KB

export const KRP_TARGET_ID = 'krp';

export const SYS_MASK: LibItemSysImage[] = [
  {
    id: 1,
    name: '720遮罩',
    url: '/imgs/mask-720.bef57de927cc47745ddcce024ad3e8e8.png',
  },
  {
    id: 2,
    name: '指南针遮罩1',
    url: '/imgs/mask-compass.65ee31505c0bfdcb040ab077efb9f6ec.png',
  },
  {
    id: 3,
    name: '指南针遮罩2',
    url: '/imgs/mask-compass2.476af62f1a3476e81bb8889d801ab3ed.png',
  },
];

export const SYS_COMPASS: LibItemSysImage[] = [
  {
    id: 1,
    name: '简洁指北针(半透明)',
    url: '/imgs/compass1.2a7c1aeb3f10d1293f1d7629a438b508.png',
  },
  {
    id: 2,
    name: '简洁指北针(白)',
    url: '/imgs/compass2.0d479c3d2a972ade064dfd328c407942.png',
  },
  {
    id: 3,
    name: '拟物指北针(白)',
    url: '/imgs/compass3.31f88745aa84da7fb08a32068e4264e0.png',
  },
  {
    id: 4,
    name: '拟物指北针(黑)',
    url: '/imgs/compass4.b3c58152f5dfe7ca91cf1bbecbdfb129.png',
  },
  {
    id: 5,
    name: '拟物指北针',
    url: '/imgs/compass5.7232f16069224158f43a34499302acf9.png',
  },
  {
    id: 6,
    name: '简洁指北针(灰)',
    url: '/imgs/compass6.25a4b2d7a8b75828708670a5c5c2b651.png',
  },
  {
    id: 7,
    name: '简洁指北针(无边框)',
    url: '/imgs/compass7.8213a49864d21a9b6f88c0f02e4a7032.png',
  },
  {
    id: 8,
    name: '文字指北针',
    url: '/imgs/compass8.1be0bbb50f8e9c93df70875b86daaa81.png',
  },
];

export const LINK_LENGTH = 500;

export const MAX_CATEGORIES = 500;

export const VIP_URL = `${HOST}/vip/720vr`;
